import React from 'react';
import Browser from 'browser';
import { Helmet } from 'react-helmet';

// Install:
// - jquery
// - react-router-dom
// - spritespin
// - react-resize-detector
// - react-keep-alive
// - react-slider
// - react-circular-progressbar
// - react-router-transition
// - @svgr/webpack gatsby-plugin-svgr]
// - react-google-maps recompose
// and other packages throwing errors

// npm i jquery react-router-dom spritespin react-keep-alive react-circular-progressbar react-router-transition @svgr/webpack gatsby-plugin-svgr react-slider react-resize-detector react-google-maps recompose

// gatsby-config.js
// {
//   resolve: 'gatsby-plugin-svgr',
//   options: {
//     prettier: true,
//     svgo: false,
//   },
// },
// import font
// {
//   family: 'Inter',
//   variants: [`400`, `500`, `600`, `700`],
//   subsets: ['latin-ext'],
// },

// modify investment in browser/investments/:investment
// modify browser/utils/getFlatsWithProperties.js to match object keys

const IndexPage = () => {
  return (
    <>
      <Helmet>
        <link
          rel="stylesheet"
          id="proxima-nova-css"
          href="https://use.typekit.net/oje8zqd.css?ver=4.9.18"
          type="text/css"
          media="all"
        />
      </Helmet>
      <Browser />
      {/* all props below are optional */}
      {/* lang - pl(default)/en, allFlats - array, loading - bool, loadingText - string */}
    </>
  );
};

export default IndexPage;
